export const createAsyncScript = ({
    src,
    attributes
}: {
    src: string;
    attributes?: Record<string, string>;
}) =>
    new Promise((resolve, reject) => {
        const hash = btoa(JSON.stringify({ src, attributes }));
        const exists = document.getElementById(hash);

        if (exists) {
            resolve(true);
            return;
        }

        const script = document.createElement('script');
        const firstNode = document.head.firstChild;

        script.type = 'text/javascript';
        script.src = src;

        script.setAttribute('defer', '');
        script.setAttribute('id', hash);

        if (attributes) {
            const attributePairs = Object.entries(attributes);
            for (const attributePair of attributePairs) {
                script.setAttribute(...attributePair);
            }
        }

        script.onload = (event) => resolve(event);
        script.onerror = (event) => reject(event);

        document.head.insertBefore(script, firstNode);
    });
